// eslint-disable-next-line import/no-cycle
import {

    // Queue Management
    QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE,
    QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE_SUCCESS,
    QUEUE_MANAGEMENT_CREATE_QUEUE,
    QUEUE_MANAGEMENT_UPDATE_QUEUE,
    QUEUE_MANAGEMENT_DELETE_QUEUE,

    // QUEUE_MANAGEMENT_LOAD_POSITION,
    // QUEUE_MANAGEMENT_LOAD_POSITION_SUCCESS,
    // QUEUE_MANAGEMENT_CREATE_POSITION,
    // QUEUE_MANAGEMENT_UPDATE_POSITION,
    // QUEUE_MANAGEMENT_DELETE_POSITION,

    // QUEUE_MANAGEMENT_LOAD_STAFF,
    // QUEUE_MANAGEMENT_LOAD_STAFF_SUCCESS,
    // QUEUE_MANAGEMENT_CREATE_STAFF,
    // QUEUE_MANAGEMENT_UPDATE_STAFF,
    // QUEUE_MANAGEMENT_DELETE_STAFF,
    // END Queue Management

} from '../actions';


// export const settingErrorMessage = (data) => ({
//     type: QUEUE_MANAGEMENT_ERROR_MESSAGE,
//     payload: data
// })

// export const closeSettingErrorMessage = () => ({
//     type: CLOSE_QUEUE_MANAGEMENT_ERROR_MESSAGE
// });

// // -------------------- Queue Management --------------------- //
export const getQueueByDate = (data, token) => ({
    type: QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE,
    payload: data,
    token
});
export const getQueueByDateSuccess = (data, list) => ({
    type: QUEUE_MANAGEMENT_LOAD_QUEUE_BY_DATE_SUCCESS,
    payload: data,
    payloadlist: list
});
export const addQueue = (data, token) => ({
    type: QUEUE_MANAGEMENT_CREATE_QUEUE,
    payload: data,
    token
});
export const updateQueue = (data, token) => ({
    type: QUEUE_MANAGEMENT_UPDATE_QUEUE,
    payload: data,
    token
});
export const deleteQueue = (data, token) => ({
    type: QUEUE_MANAGEMENT_DELETE_QUEUE,
    payload: data,
    token
});
//
// export const getPosition = (data, token) => ({
//     type: QUEUE_MANAGEMENT_LOAD_POSITION,
//     payload: data,
//     token
// });
// export const getPositionSuccess = (data, list) => ({
//     type: QUEUE_MANAGEMENT_LOAD_POSITION_SUCCESS,
//     payload: data,
//     payloadlist: list
// });
// export const addPosition = (data, token) => ({
//     type: QUEUE_MANAGEMENT_CREATE_POSITION,
//     payload: data,
//     token
// });
// export const updatePosition = (data, token) => ({
//     type: QUEUE_MANAGEMENT_UPDATE_POSITION,
//     payload: data,
//     token
// });
// export const deletePosition = (data, token) => ({
//     type: QUEUE_MANAGEMENT_DELETE_POSITION,
//     payload: data,
//     token
// });
// //
// export const getStaff = (data, token) => ({
//     type: QUEUE_MANAGEMENT_LOAD_STAFF,
//     payload: data,
//     token
// });
// export const getStaffSuccess = (data, list) => ({
//     type: QUEUE_MANAGEMENT_LOAD_STAFF_SUCCESS,
//     payload: data,
//     payloadlist: list
// });
// export const createStaff = (data, token) => ({
//     type: QUEUE_MANAGEMENT_CREATE_STAFF,
//     payload: data,
//     token
// });
// export const updateStaff = (data, token) => ({
//     type: QUEUE_MANAGEMENT_UPDATE_STAFF,
//     payload: data,
//     token
// });
// export const deleteStaff = (data, token) => ({
//     type: QUEUE_MANAGEMENT_DELETE_STAFF,
//     payload: data,
//     token
// });
// // -------------------- END Queue Management --------------------- //